import type { BackendVault } from '@/types'

export function isVaultInTvlRange(vault: BackendVault, range: [number, number]): boolean {
  if (!vault.tvlInUsd) return false
  return vault.tvlInUsd >= range[0] && vault.tvlInUsd <= range[1]
}
